import {
  type JSX,
  Show,
  createEffect,
  createMemo,
  createSignal,
  on,
} from "solid-js";
import { Portal } from "solid-js/web";

import { isMobile } from "@/lib/isMobile";

type ExpandAnimationWrapperProps = {
  state: boolean;
  children: JSX.Element;
  direction?: "horizontal" | "vertical";
  zIndex?: number;
  /** 是否启用移动端遮罩，默认 true */
  enableMask?: boolean;
  onTransitionEnd?: () => void;
};

export function ExpandAnimationWrapper(props: ExpandAnimationWrapperProps) {
  const [expanded, setExpanded] = createSignal(false);

  const isVertical = props.direction === "vertical" || !props.direction;
  const enableMask = props.enableMask ?? true;

  createEffect(
    on(
      createMemo(() => props.state),
      (boolean) => {
        setExpanded(boolean);
      },
    ),
  );

  return (
    <div
      onTransitionEnd={props.onTransitionEnd}
      style={{
        display: "grid",
        /* prettier-ignore */
        "grid-template-rows": isVertical ? (expanded() ? "1fr" : "0fr") : "1fr",
        /* prettier-ignore */
        "grid-template-columns": !isVertical ? (expanded() ? "1fr" : "0fr") : "1fr",
        transition: `grid-template-rows 0.3s ease, 
                       grid-template-columns 0.3s ease
                      `,
        overflow: "hidden",
        "pointer-events": expanded() ? "auto" : "none",
        "will-change": "grid-template-columns, grid-template-rows",
        "white-space": "normal",
      }}
    >
      <div style={{ overflow: "hidden" }}>{props.children}</div>

      <Show when={isMobile() && expanded() && enableMask} fallback={<></>}>
        <Portal>
          <div
            class="mask-fade-in fixed bottom-0 left-0 right-0 top-0 bg-black/50"
            style={{
              "z-index": props.zIndex || 40,
            }}
          />
        </Portal>
      </Show>
    </div>
  );
}
